import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
/* actions */
import { addPABXs } from '../../redux/actions/pabxs';
import { getAllDepartments } from '../../redux/actions/departments';
/* components */
import ErrorMsgField from '../../components/ErrorMsgField';
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
/* form-validation */
import schema from '../../form-validation/pabx';
/* utils */
import handleChangeDefault from '../../utils/handleChangeDefault';

function Add () {
  const INITIAL_VALUES = {
    name: '',
    department: '',
    supervisorDevice: '',
    manufacturer: '',
    model: '',
    ip: '',
    port: '',
    extensions: '',
    groups: '',
    ogms: '',
    networks: '',
    localCode: ''
  };
  const dispatch = useDispatch();
  const submitButton = useRef();
  const { register, handleSubmit, errors, reset } = useForm({
    validationSchema: schema,
    reValidateMode: 'onSubmit'
  });
  const pabxs = useSelector(state => state.pabxs);
  const departments = useSelector(state => state.departments);
  const [data, setData] = useState(INITIAL_VALUES);

  useEffect(() => {
    dispatch(getAllDepartments());
  }, [dispatch]);

  const submit = () => {
    const resetForm = () => {
      reset();
      setData({ ...INITIAL_VALUES });
    };
    dispatch(addPABXs(data, resetForm, submitButton.current));
  };

  return (
    <div className="container-fluid">
      {pabxs.addSuccess && (
        <AlertMsg type="success" msg="PABX cadastrado com sucesso" />
      )}
      {pabxs.errorContent &&
        !pabxs.errorContent.message.includes('400') &&
        pabxs.addError && (
        <AlertMsg type="danger" msg="Falha durante cadastro do PABX" />
      )}
      {pabxs.errorContent &&
        pabxs.errorContent.message.includes('400') &&
        pabxs.addError && (
        <AlertMsg
          type="danger"
          msg="Um PABX com ip informado já está cadastrado"
        />
      )}
      {!pabxs.addSuccess && !pabxs.addError && (
        <AlertMsg type="info" msg="Área cadastro de PABX" />
      )}
      <FormHeader title="Cadastrar PABX" />
      <form id="form" onSubmit={handleSubmit(submit)}>
        <div className="form-group">
          <label htmlFor="name">
            Nome<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            autoComplete="off"
            value={data.name}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          />
          {errors.name && errors.name.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
          {errors.name && errors.name.type === 'max' && (
            <ErrorMsgField type="max" />
          )}
          {errors.name && errors.name.type === 'min' && (
            <ErrorMsgField type="min" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="department">
            Departamento<span className="field-required">*</span>
          </label>
          <select
            className="form-control"
            id="department"
            name="department"
            value={data.department}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          >
            <option value="">-- Selecione --</option>
            {departments.data.map((dpt, i) => {
              const _id = dpt._id || Date.now() + '' + i;
              return (
                <option key={_id} value={_id}>
                  {dpt.name}
                </option>
              );
            })}
          </select>
          {errors.department && errors.department.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="supervisorDevice">
            Ramal Supervisor PABX<span className="field-required">*</span>
          </label>
          <input
            type="text"
            number="on"
            className="form-control"
            id="supervisorDevice"
            name="supervisorDevice"
            autoComplete="off"
            value={data.supervisorDevice}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          />
          {errors.supervisorDevice &&
            errors.supervisorDevice.type === 'typeError' && (
            <ErrorMsgField type="typeError" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="manufacturer">
            Fabricante<span className="field-required">*</span>
          </label>
          <select
            className="form-control"
            id="manufacturer"
            name="manufacturer"
            value={data.manufacturer}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          >
            <option value="">-- Selecione --</option>
            <option value="panasonic">Panasonic</option>
          </select>
          {errors.manufacturer && errors.manufacturer.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="model">
            Modelo<span className="field-required">*</span>
          </label>
          <select
            className="form-control"
            id="model"
            name="model"
            value={data.model}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          >
            <option value="">-- Selecione --</option>
            <option value="NS">NS</option>
            <option value="NSX">NSX</option>
            <option value="TDE">TDE</option>
          </select>
          {errors.model && errors.model.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="ip">
            IP<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="ip"
            name="ip"
            autoComplete="off"
            value={data.ip}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          />
          {errors.ip && errors.ip.type === 'ipV4' && (
            <ErrorMsgField type="ipV4" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="port">
            Porta CSTA<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="port"
            name="port"
            number="on"
            autoComplete="off"
            value={data.port}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          />
          {errors.port && errors.port.type === 'min' && (
            <ErrorMsgField type="min" />
          )}
          {errors.port && errors.port.type === 'max' && (
            <ErrorMsgField type="max" />
          )}
          {errors.port && errors.port.type === 'typeError' && (
            <ErrorMsgField type="typeError" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="extensions">
            Qtd. Ramais<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="extensions"
            name="extensions"
            number="on"
            autoComplete="off"
            value={data.extensions}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          />
          {errors.extensions && errors.extensions.type === 'min' && (
            <ErrorMsgField type="min" />
          )}
          {errors.extensions && errors.extensions.type === 'max' && (
            <ErrorMsgField type="max" />
          )}
          {errors.extensions && errors.extensions.type === 'typeError' && (
            <ErrorMsgField type="typeError" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="groups">
            Qtd. Grupos<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="groups"
            name="groups"
            number="on"
            autoComplete="off"
            value={data.groups}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          />
          {errors.groups && errors.groups.type === 'min' && (
            <ErrorMsgField type="min" />
          )}
          {errors.groups && errors.groups.type === 'max' && (
            <ErrorMsgField type="max" />
          )}
          {errors.groups && errors.groups.type === 'typeError' && (
            <ErrorMsgField type="typeError" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="ogms">
            Qtd. OGMs<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="ogms"
            name="ogms"
            number="on"
            autoComplete="off"
            value={data.ogms}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          />
          {errors.ogms && errors.ogms.type === 'min' && (
            <ErrorMsgField type="min" />
          )}
          {errors.ogms && errors.ogms.type === 'max' && (
            <ErrorMsgField type="max" />
          )}
          {errors.ogms && errors.ogms.type === 'typeError' && (
            <ErrorMsgField type="typeError" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="networks">
            Qtd. Troncos<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="networks"
            name="networks"
            number="on"
            autoComplete="off"
            value={data.networks}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          />
          {errors.networks && errors.networks.type === 'min' && (
            <ErrorMsgField type="min" />
          )}
          {errors.networks && errors.networks.type === 'max' && (
            <ErrorMsgField type="max" />
          )}
          {errors.networks && errors.networks.type === 'typeError' && (
            <ErrorMsgField type="typeError" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="localCode">
            Código de Área<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="localCode"
            name="localCode"
            number="on"
            autoComplete="off"
            value={data.localCode}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          />
          {errors.localCode && errors.localCode.type === 'min' && (
            <ErrorMsgField type="min" />
          )}
          {errors.localCode && errors.localCode.type === 'max' && (
            <ErrorMsgField type="max" />
          )}
          {errors.localCode && errors.localCode.type === 'typeError' && (
            <ErrorMsgField type="typeError" />
          )}
        </div>
        <FormFooter url="/pabxs" reference={submitButton} />
      </form>
    </div>
  );
}

export default Add;
